import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const GeniusScoreboardWrapper = withConfig(theme => styled('div', { label: 'GeniusScoreboardWrapper' })<{ minHeight?: number }>`
    width: 100%;
    min-height: ${({ minHeight }): number => minHeight ?? 90}px;
    background-color: ${theme.star.unified.liveTracker.bgWrapperColor};
`);

export const GeniusScoreboardIframe = withConfig(theme => styled('iframe', { label: 'GeniusScoreboardIframe' })<{ minHeight?: number }>`
    width: 100%;
    height: ${({ minHeight }): number => minHeight ?? 100}px;
    min-height: ${({ minHeight }): number => minHeight ?? 100}px;
    border: none;
    display: block;
    background-color: ${theme.star.unified.liveTracker.bgWrapperColor};
`);